/**
* @copyright
* Copyright(c) 2018 SICK AG
*/

const style = `
:host {
  box-sizing: border-box;
  font-size: 1rem;
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: #737F85;
  background-color: var(--davinci-color-secondary, #737F85);
  color: #FFFFFF;
  color: var(--davinci-color-text-on-secondary, #FFFFFF);
  fill: #FFFFFF;
  fill: var(--davinci-color-text-on-secondary, #FFFFFF);
  width: 3.4285714286rem;
  position: relative;
  flex-grow: 1;
}

:host(.expanded) {
  width: 20vw;
  min-width: 18.2857142857rem;
  max-width: 22.8571428571rem;
}

.children {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow: auto;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
}

.toggle-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 3.4285714286rem; /* iPad-fix */
  border-top: 0.0714285714rem solid var(--davinci-color-text-on-secondary,#FFFFFF);
  margin-top: 1.7142857143rem;
}

:host(.expanded) .toggle-container {
  align-items: flex-end;
}

.icon-box {
  padding: 0.8571428571rem;
}
.icon-box:hover {
  cursor: pointer;
  background-color: #009DF4;
  background-color: var(--davinci-color-primary-light, #009DF4);
}

.icon {
  min-width: 1.7142857143rem;
  min-height: 1.7142857143rem;
  width: 1.7142857143rem;
  height: 1.7142857143rem;
}

.scrollbar-container {
  position: absolute;
  right: 0rem;
  padding-right: 0.2857142857rem;
  width: 0.4285714286rem;
  overflow: hidden;
}
.scrollbar-container.hidden {
  width: 0;
  padding: 0;
}

.scrollbar {
  position: absolute;
  width: 0.4285714286rem;
  border-radius: 0.2142857143rem;
  background-color: #B1B8BC;
  background-color: var(--davinci-color-text-disabled, #B1B8BC);
  margin: 0.1428571429rem 0;
  display: none;
}

:host(:hover) .scrollbar.visible,
.scrollbar.visible.dynamic {
  display: block;
}

:host .children {
  /* Hide scrollbars */
  -ms-overflow-style: none;
  scrollbar-width: none;
}
:host .children::-webkit-scrollbar {
  display: none;
}
`;
export { style };
